'use client';
import AppLayout from '@/components/AppLayout';
import AutoValuationClient from './components/AutoValuationClient';

export default function AutoValuationPage() {
  return (
    <AppLayout>
      <AutoValuationClient />
    </AppLayout>
  );
}
